import { Link, useLocation } from "react-router-dom";
import { Mail } from "lucide-react";
import OwlLogo from "./OwlLogo";

export const Footer = () => {
  const location = useLocation();
  if (location.pathname === "/admin") return null;

  return (
    <footer className="bg-chalk text-paper mt-0" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <OwlLogo className="w-10 h-10" />
            <span className="font-serif font-bold text-xl">
              Chouette <span className="italic text-coral">Apprentissage</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-paper/70 leading-relaxed max-w-xs">
            Le compagnon virtuel qui accompagne les enfants du CP à la Terminale dans leurs devoirs et leur envie d'apprendre.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-sm text-paper/80" data-testid="footer-domain">
            chouetteapprentissage.com
          </p>
        </div>

        <div>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-paper/50">Explorer</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/#app" className="hover:text-coral transition-colors" data-testid="footer-link-app">Le compagnon</Link></li>
            <li><Link to="/#niveaux" className="hover:text-coral transition-colors" data-testid="footer-link-niveaux">Du CP à la Terminale</Link></li>
            <li><Link to="/#activites" className="hover:text-coral transition-colors" data-testid="footer-link-activites">Les activités</Link></li>
            <li><Link to="/#parents" className="hover:text-coral transition-colors" data-testid="footer-link-parents">Espace parents</Link></li>
            <li><Link to="/support" className="hover:text-coral transition-colors" data-testid="footer-link-support">Support</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-paper/50">Informations</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/confidentialite" className="hover:text-coral transition-colors" data-testid="footer-link-privacy">Politique de confidentialité</Link></li>
            <li><Link to="/cgu" className="hover:text-coral transition-colors" data-testid="footer-link-cgu">Conditions générales d'utilisation</Link></li>
            <li><Link to="/support" className="hover:text-coral transition-colors" data-testid="footer-link-contact">Nous contacter</Link></li>
            <li>
              <a href="mailto:support@chouetteapprentissage.com" className="inline-flex items-center gap-2 hover:text-coral transition-colors" data-testid="footer-link-mail">
                <Mail className="w-4 h-4" /> support@chouetteapprentissage.com
              </a>
            </li>
            <li><Link to="/admin" className="text-paper/40 hover:text-paper/80 transition-colors text-xs" data-testid="footer-link-admin">Console d'administration</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-paper/10">
        <p className="max-w-7xl mx-auto px-6 py-6 text-xs text-paper/50">
          © {new Date().getFullYear()} Chouette Apprentissage — Tous droits réservés.
        </p>
      </div>
    </footer>
  );
};

export default Footer;